// CHECK STATUS AND RETURN
export default function(response) {
  if (response.status === 200) {
    return response;
  }
}
